export default __webpack_public_path__ + "static/media/NTEX CLASS-8 EXAM PATTERN 2026-27.5e9f1b6a.pdf";